module.exports = __webpack_public_path__ + "media/images/vp/slider.index.05-12df08cd351ac26335b50022a9bde7c2.jpg";